import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

export const AreaTooltipContent = memo(() => (
    <p className="vss-area-tooltip-content">
        <I18n messageId={MESSAGES.actuatorsUserInputAreaInfo}/>
    </p>
));
